import { useEffect, useState } from "react";
import Animated, {
	useAnimatedStyle,
	useSharedValue,
	withRepeat,
	withSequence,
	withTiming,
} from "react-native-reanimated";
import share_default from "src/assets/lottie/share_default/share_default.lottie";
import Lottie from "src/components/Lottie";
import { paddingLarge } from "src/styles/spacing";
import { Text } from "src/swsh-native";

const CopyVariants: string[] = [
	"Creating your perfect cover...",
	"Making magic happen...",
	"Generating your masterpiece...",
];

const GenerationLoading = () => {
	const [description] = useState(() => {
		return CopyVariants[Math.floor(Math.random() * CopyVariants.length)];
	});
	const opacitySV = useSharedValue(1);
	const animatedStyle = useAnimatedStyle(() => {
		return {
			opacity: opacitySV.value,
		};
	}, [opacitySV]);

	useEffect(() => {
		opacitySV.value = withRepeat(
			withSequence(withTiming(0.6, { duration: 1500 }), withTiming(1, { duration: 1500 })),
			-1,
		);
	}, [opacitySV]);

	return (
		<>
			<Lottie
				source={share_default}
				autoPlay
				loop
				style={{
					flex: 1,
					width: "100%",
				}}
			/>
			<Animated.View
				style={[
					animatedStyle,
					{
						marginTop: paddingLarge,
						alignItems: "center",
						justifyContent: "center",
					},
				]}
			>
				<Text testID="GenerateLoading" semiLarge color="TextLight">
					{description}
				</Text>
			</Animated.View>
		</>
	);
};
export default GenerationLoading;
